export default __webpack_public_path__ + "static/media/JobFive2.c737a384.jpg";